import { SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { ManagedAccountFieldTypeValue } from "@models/managed-accounts/enums/fieldTypeValue";
import { memo } from "react";
import { DynamicNumberCell } from "../dynamic-number-cell";

interface PercentageCellProps {
  analysisData?: MAAnalysisDataDTO;
}

export const PercentageCell = memo(({ analysisData }: PercentageCellProps) => {
  const { value } = analysisData || {};

  if (analysisData?.isMultiple && analysisData.tooltip) {
    return (
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        {analysisData.value === ManagedAccountFieldTypeValue.Multiple
          ? ManagedAccountFieldTypeValue.Multiple
          : `${analysisData?.value}%`}
      </SHTypography>
    );
  }

  return (
    <DynamicNumberCell
      value={value}
      suffix={"%"}
      decimalScale={3}
      forceDecimalScale={false}
      renderValue={(value) => (
        <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
          {value}
        </SHTypography>
      )}
    />
  );
});
